
import { Component, Vue } from "vue-property-decorator";
import Footerr from "@/components/Footerr.vue";
import Headerr from "@/components/Headerr.vue";
import Service from "@/components/Service.vue";
import Nav from "@/components/Nav.vue";

export default Vue.extend({
  name: "home",
  components: {
    Footerr,
    Headerr,
    Service,
    Nav,
  },
  data() {
    return {
      fullSlider: 0,
      //      slidesNum: 5,
      solutions: [
        {
          id: 1,
          title: "Home.solutions.Box1.title",
          titleKey: "LAN",
          description: "Home.solutions.Box1.text",
          img: "solu1.png",
        },
        {
          id: 2,
          title: "Home.solutions.Box2.title",
          titleKey: "WAN",
          description: "Home.solutions.Box2.text",
          img: "solu2.png",
        },
        {
          id: 3,
          title: "Home.solutions.Box3.title",
          titleKey: "",
          description: "Home.solutions.Box3.text",
          img: "solu3.png",
        },
        {
          id: 4,
          title: "Home.solutions.Box4.title",
          titleSpan: "Home.solutions.Box4.tSpan",
          titleKey: "",
          description: "Home.solutions.Box4.text",
          img: "solu4.png",
        },
      ],
    };
  },
  methods: {
    prev() {
      if (this.fullSlider <= 0) {
        this.fullSlider = this.slidesNum - 1;
      } else {
        this.fullSlider--;
      }
    },
    next() {
      if (this.fullSlider >= this.slidesNum - 1) {
        this.fullSlider = 0;
      } else {
        this.fullSlider++;
      }
    },
  },
});
